import React from 'react';

import { Icon } from '@ontruck/orc';

const CommentsCell = ({ hasComments }) => {
  if (!hasComments) {
    return null;
  }

  return <Icon glyph="comments" size="1.6rem" color="grey500" />;
};

export default CommentsCell;
